// extracted by mini-css-extract-plugin
export var adjacentSlide = "_t2-9";
export var arrowButtonContainer = "_t2-5";
export var arrowButtonIcon = "_t2-6";
export var carouselArrowButton = "_t2-2";
export var carouselElementContainer = "_t2-1";
export var currentSlide = "_t2-8";
export var left = "_t2-3";
export var otherSlide = "_t2-a";
export var productCarouselContainer = "_t2-0";
export var right = "_t2-4";
export var sliderOverflow = "_t2-7";